export class AuditorBenchAuditDetailDTO {
    pendingSelected: boolean = false;
    inWfSelected: boolean = false;
    ncSelected: boolean = false;
    pncSelected: boolean = false;
    closedSelected: boolean = false;
    naSelected: boolean = false;
    allSelected: boolean = false;
    returnSelected: boolean = false;
    notStartedSelected: boolean = false;
    planSelected: boolean = false;
    doSelected: boolean = false;
    checkSelected: boolean = false;
    actSelected: boolean = false;
    riskRatingSelected: boolean = false;
    approved: string = "0";
    pending: string = "0";
    inWf: string = "0";
    nc: string = "0";
    ncOpen: string = "0";
    ncClosed: string = "0";
    pnc: string = "0";
    pncOpen: string = "0";
    pncClosed: string = "0";
    closed: string = "0";
    na: string = "0";
    all: string = "0";
    returned: string = "0";
    notStarted: string = "0";
    plan: string = "0";
    doing: string = "0";
    check: string = "0";
    act: string = "0";

    riskRating: string = "0";
    riskRatingId: string = "0";

    auditProgramId: string = "0";
    auditProgramStatus: string = "0";
    auditProgramStage: string = "0";
    departmentId: string = "0";
    sectionId: string = "0";
    scopeId: string = "0";

    selectedDepartmentId: string = "0";
    selectedSectionId: string = "0";
    selectedBusinessProcessDesc: string = "";

    scopePrivilege: string = "";
    auditFirmId: string = "0";

    isWorkflowRequired: string = "0";
    targetDate: string = "";
    revisedTargetDate: string = "";
    managementComment: string = "";
    pncManagementComment: string = "";
    pdcaStatus: string = "";
    actionType: string = "";
    isPnc: string = "";
    isObservationApplicable = "";
    auditeeDetailDTO: string;
    auditAreaId: string;
}